module.exports = "/_next/static/images/ScottBrinker-36279b9fc4b8f65667ca0565019c6d4e.png";